export const en = {
  'signals-ng-shared-services': {
    common: {
      error: {
        circularDependency: 'We detected a circular dependency in the search definition and removed it.'
      }
    },
    propertyLabels: {
      notAssigned: '(No Value)'
    }
  }
};
